module.exports = __webpack_public_path__ + "static/media/stats-icon.e9cfdc03.svg";